// One local server for owner, onboarding, and visitor Discovery requests.
// MODE also covers `vite build --mode development`, where DEV is false.
export const usesLocalBackend = () => import.meta.env.DEV || import.meta.env.MODE === "development";

export function resolveBackendEndpoint(
  operation: string,
  development = usesLocalBackend(),
): string {
  if (development) {
    const base = import.meta.env["VITE_BACKEND_BASE_URL"]?.trim() || "http://127.0.0.1:8085";
    return `${base.replace(/\/+$/, "")}/${operation}`;
  }
  // Preserve deployed per-function overrides. They never affect local routing.
  const configured = import.meta.env[`VITE_BACKEND_${operation.toUpperCase()}_URL`]?.trim();
  return configured || `https://us-central1-quote-stripe.cloudfunctions.net/${operation}`;
}
